/** Helper nomor & link WhatsApp (wa.me) — tanpa API berbayar. */
export const COUNTRY_CODES = [
  { code: "81", label: "🇯🇵 +81" },
  { code: "62", label: "🇮🇩 +62" },
  { code: "60", label: "🇲🇾 +60" },
  { code: "65", label: "🇸🇬 +65" },
];

/** Ubah nomor lokal (mis. 090-1234-5678) ke format internasional tanpa tanda "+". */
export const waNumber = (raw, cc = "81") => {
  let n = String(raw || "").replace(/[^0-9+]/g, "");
  if (n.startsWith("+")) return n.slice(1);
  if (n.startsWith("00")) return n.slice(2);
  if (n.startsWith(cc) && n.length > String(cc).length + 6) return n;
  return `${cc}${n.replace(/^0+/, "")}`;
};

export const waLink = (raw, text = "", cc = "81") => {
  const n = waNumber(raw, cc);
  if (n.length < 8) return "";
  return `https://wa.me/${n}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

export const telLink = (raw) => {
  const n = String(raw || "").replace(/[^0-9+]/g, "");
  return n ? `tel:${n}` : "";
};
